<template>
  <div>
    <EbHeading level="h1" class="eb-page-heading">Plan du site</EbHeading>
    
    <div class="eb-content-default">
      <ul class="list">
      <li v-for="item in orderedPages" v-if="item.path != '*'">
        <router-link :to="item.path">
          {{item.name}}
        </router-link>
      </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: []
    }
  },
  created() {
    this.$router.options.routes.forEach(route => {
      if(!route.meta.isPublic && !route.notInSitemap) {
        this.items.push({
          name: route.meta.title,
          path: route.path
        })
      }
    })
  },
  computed: {
    orderedPages: function() {
      return this.items.sort((a,b) => a.name.localeCompare(b.name))
    }
  }
}
</script>